var VrHeaderCategories = function(params) {
    var _this = this,
        _getCatAjaxUrl = '/brochures/related_by_city_brand',
        _catNavSel = '.vr-cat-nav-item',
        _jsLoadedClass = 'js-loaded',
        _defaultLimit = 8,
        _cachedCats = [];

    function _errorCallback(err) {
        console.log("ajax error: ", err);
    }

    function _getRelatedBrochruesByCatAndCityId(categoryId, cityId, $el) {
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: _getCatAjaxUrl,
            success: function(data){
                _displayRelatedByCat(data, categoryId);
                $el.addClass(_jsLoadedClass);
            },
            error: _errorCallback,
            data: {
                limit: _defaultLimit,
                category_id: categoryId,
                city_id: cityId,
                brochure_id: brochureId
            }
        });
    }

    function _displayRelatedByCat(data, categoryId){
        // console.log("data", data);

        if (typeof data !== 'undefined' && data != '') {
            _cachedCats["cat_" + categoryId] = data;

            var _relatedCatWrapSel =  '.vr-cat-top-brands-inner-wrap',
                _relatedBrArr = [];
            
            $.each(data.related_brochures, function(inx, item){
                var _relatedBr = document.createElement('div');
                _relatedBr.className = 'vr-cat-related-br col-xs-6 col-sm-4 col-md-3 col-lg-5th';
                _relatedBr.innerHTML = '<a class="vr-cat-related-br__item" href="' + item.brochure_link + '" onclick="ga(\'send\', \'event\', \'brochure-view-' + (isMobile ? 'mobile' : 'desktop') +'\', \'similar-brochure-header-menu\', \'' + item.brochure_link + '\');">' +
                                        '<p class="vr-cat-related-br__title">' + item.brand_name + '</p>' + 
                                        // '<div class="vr-cat-related-br__back" style="background-image: url(' + item.cover + ');"></div>' + 
                                        '<img class="vr-cat-related-br__img" data-offerista-id="' + item.offerista_id + '" src="' + item.cover + '" alt="' + item.brand_name + '"/ >' +
                                        '</a>';
                
                _relatedBrArr.push(_relatedBr);
            });

            $(_relatedCatWrapSel).html(_relatedBrArr);
                // _populateCategoriesTopBrands(data, $el);
                // _populateCategoryImgAndTxt(data, $el);
        }
    }
    

    function _handleClicks(){
        $(document).on(isMobile ? 'click' : 'mouseenter', '.vr-cat-nav-wrap .vr-cat-nav-item', function(e){
            var $el = $(this),
                categoryId = $el.data('category-id'),
                categoryName = typeof viewVersion !== 'undefined' && viewVersion === '3' ? $el.text().trim() : $el.text().trim() + '-click',
                _catGaAction = typeof viewVersion !== 'undefined' && viewVersion === '3' ? 'header-menu-category' : 'similar-brochure-header-menu';

            $('.vr-cat-nav-wrap .vr-cat-nav-item').removeClass('vr-cat-nav-item_hovered');
            $el.addClass('vr-cat-nav-item_hovered');

            if($el.hasClass(_jsLoadedClass) == false){
                _getRelatedBrochruesByCatAndCityId(categoryId, city_id, $el);
            }else{
                _displayRelatedByCat(_cachedCats["cat_" + categoryId], categoryId, $el);
            }

            $('.vr-cat-top-brands__header-title').text($el.text().trim());
            ga('send', 'event', 'brochure-view-' + (isMobile ? 'mobile' : 'desktop'), _catGaAction, categoryName);
        });
    }
    

    function _init() {
        _handleClicks();
    }

    _init();

    _this.init = _init;
};